export class ApiError extends Error {
  constructor(public status: number, public payload: unknown) {
    super(`api ${status}`);
  }

  /** The server's stable error_id for 500 responses, if returned. */
  get errorId(): string | null {
    const p = this.payload as { error_id?: unknown } | null | undefined;
    return typeof p?.error_id === 'string' ? p.error_id : null;
  }

  /** Shortcut: the error code string the server returned, if any. */
  get code(): string | null {
    const p = this.payload as { error?: unknown } | null | undefined;
    return typeof p?.error === 'string' ? p.error : null;
  }
}

export interface FetchOptions {
  method?: 'GET' | 'POST' | 'PATCH' | 'DELETE' | 'PUT';
  body?: unknown;
  workspaceId?: string | null;
  signal?: AbortSignal;
}

export async function api<T>(path: string, opts: FetchOptions = {}): Promise<T> {
  const headers: Record<string, string> = { 'accept': 'application/json' };
  if (opts.body !== undefined) headers['content-type'] = 'application/json';
  if (opts.workspaceId) headers['x-workspace-id'] = opts.workspaceId;

  const res = await fetch(`/api${path}`, {
    method: opts.method ?? 'GET',
    headers,
    credentials: 'include',
    body: opts.body === undefined ? undefined : JSON.stringify(opts.body),
    signal: opts.signal,
  });

  const text = await res.text();
  const data = text ? safeJson(text) : null;
  if (!res.ok) throw new ApiError(res.status, data);
  return data as T;
}

function safeJson(s: string): unknown {
  try { return JSON.parse(s); } catch { return s; }
}
